// Linked Cody Macs (docs/research/pair-a-cody.md › Sharing devices): when this device's Mac shared it with another Cody Mac
// it linked to, the Mac's `devices` answer names that Mac — its room, its name, its identity key. This adds it to the Macs
// this browser already keeps (transport.js `cody.rooms`, pairing.js pins), so it connects to it directly like any paired
// Mac (macs.js) — even when the first Mac is off. A Mac already on the list is left exactly as it is: never re-pinned,
// never renamed. Returns the rooms it added.
import { savedRooms, rememberRoom } from './transport.js'
import { pins } from './pairing.js'

const ROOM = /^[a-f0-9]{32,64}$/
const KEY = /^[A-Za-z0-9_-]{60,200}$/

export function learnLinkedMacs(list, { saved = savedRooms, remember = rememberRoom, pin = pins } = {}) {
  const have = new Set(saved().map((r) => r.room))
  const added = []
  for (const m of Array.isArray(list) ? list.slice(0, 20) : []) {
    if (!ROOM.test(m?.room || '') || !KEY.test(m?.macKey || '') || have.has(m.room)) continue
    remember(m.room, String(m.mac || 'a Mac').slice(0, 60))
    pin.set(m.room, m.macKey)
    have.add(m.room)
    added.push(m.room)
  }
  return added
}
